import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import axios from 'axios';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { filter, isEmpty, map, reverse, split } from 'lodash';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { IoCamera } from 'react-icons/io5';
import { MdFlipCameraIos, MdLocationOn } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Webcam from 'react-webcam';
import * as Yup from 'yup';
import BIP from '../../assets/images/BIP.jpeg';
import fileUploadService from '../../services/fileUploadService';
import {
  addGpsUnitsPhoto,
  getGpsUnitsPhoto,
} from '../../services/ambulanceServices';
import { UserHeader } from '../../components/AdminHeader';
import Footer from '../../components/Footer';
import { ImageModal } from '../supervisor/SupervisorForm';
import { openDB, addLocation } from './../../idb';
import Piexif from 'piexifjs';
import { dataURLtoFile, getAddressFromCoords } from '../../common';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import ChatIcon from '@mui/icons-material/Chat';
import ControlRoomChat from '../../chat/ControlRoomChat';
import CUChat from '../../chat/CUChat';

const AmbulanceTracker = () => {
  const { id } = useParams();
  const webcamRef = useRef();
  const timeoutRef = useRef(null);
  const navigate = useNavigate();
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [error, setError] = useState(null);
  const [isStart, setIsStart] = useState(false);
  const [isCaptureId, setIsCaptuerId] = useState(false);
  const [ambulanceDetail, setAmbulanceDetail] = useState({});
  const [url, setUrl] = useState(null);
  const [captureId, setCaptureId] = useState(null);
  const [gpsData, setGpsData] = useState([]);
  const [medicalList, setMedicalList] = useState([]);
  const [facingMode, setFacingMode] = useState('environment'); // Default to front camera
  const [watchID, setWatchID] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(true);
  const API_URL = `${process.env.REACT_APP_API_URL}/gps_unit/${id}`;

  const toggleCamera = () => {
    setFacingMode((prevMode) => (prevMode === 'user' ? 'environment' : 'user'));
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  useEffect(() => {
    const fetchLocation = async () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            setLatitude(latitude);
            setLongitude(longitude);

            const locationData = {
              latitude,
              longitude,
            };

            // Try sending the data online
            try {
              // await fetch(API_URL, {
              //   method: 'PUT',
              //   body: {
              //     latitude: latitude || null,
              //     longitude: longitude || null,
              //   },
              // });

              axios.put(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`, {
                latitude: latitude || null,
                longitude: longitude || null,
              });
            } catch (err) {
              console.error('Offline, saving to IndexedDB:', err);

              // Save to IndexedDB if offline
              const db = await openDB();
              await addLocation(db, locationData);

              // Register Background Sync
              if ('serviceWorker' in navigator && 'SyncManager' in window) {
                const registration = await navigator.serviceWorker.ready;
                await registration.sync.register('sync-locations');
              } else {
                console.warn('Background Sync is not supported.');
              }
            }
          },
          (err) => {
            setError(`Failed to fetch location: ${err.message}`);
          },
          { enableHighAccuracy: true, timeout: 5000 }
        );
      } else {
        setError('Geolocation is not supported by this browser.');
      }
    };

    // Fetch location every 5 seconds
    const intervalId = setInterval(fetchLocation, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, []);

  // const locationRef = useRef({ latitude: null, longitude: null });
  // const locationIdRef = useRef(null);
  // const intervalIdRef = useRef(null);

  // // Function to handle position updates
  // const handlePosition = (position) => {
  //   const { latitude, longitude } = position.coords;
  //   setLatitude(latitude); // Update latitude state
  //   setLongitude(longitude); // Update longitude state

  //   // Update the ref with the latest position
  //   locationRef.current = { latitude, longitude };

  //   // Send the updated location to the API immediately
  //   sendLocationToAPI(latitude, longitude);
  // };

  // // Function to send the location to the API
  // const sendLocationToAPI = (latitude, longitude) => {
  //   axios
  //     .put(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`, {
  //       latitude: latitude || null,
  //       longitude: longitude || null,
  //     })
  //     .catch((err) => {
  //       console.error('Failed to update location:', err);
  //     });
  // };

  // // Function to start location tracking
  // const getLocationUpdate = () => {
  //   if (navigator.geolocation) {
  //     locationIdRef.current = navigator.geolocation.watchPosition(
  //       handlePosition,
  //       (err) => {
  //         setError('Error getting location');
  //         console.error('Error in getting location:', err);
  //       },
  //       { enableHighAccuracy: true, maximumAge: 0, timeout: 27000 }
  //     );
  //   } else {
  //     alert('Sorry, your browser does not support geolocation!');
  //   }
  // };

  // // Function to send location periodically every 5 seconds
  // const sendLocationPeriodically = () => {
  //   intervalIdRef.current = setInterval(() => {
  //     const { latitude, longitude } = locationRef.current;
  //     if (latitude && longitude) {
  //       sendLocationToAPI(latitude, longitude);
  //     }
  //   }, 5000); // Send location every 5000 ms
  // };

  // // Initial location update
  // useEffect(() => {
  //   getLocationUpdate();
  //   sendLocationPeriodically();

  //   // Cleanup on component unmount (when user logs out or closes the tab)
  //   const handleBeforeUnload = () => {
  //     if (locationIdRef.current != null) {
  //       navigator.geolocation.clearWatch(locationIdRef.current);
  //     }
  //     if (intervalIdRef.current != null) {
  //       clearInterval(intervalIdRef.current); // Stop the interval
  //     }
  //   };

  //   // Listen for beforeunload event to stop execution when the page is closed or the user logs out
  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   // Cleanup on component unmount
  //   return () => {
  //     if (locationIdRef.current != null) {
  //       navigator.geolocation.clearWatch(locationIdRef.current);
  //     }
  //     if (intervalIdRef.current != null) {
  //       clearInterval(intervalIdRef.current); // Stop the interval
  //     }
  //     window.removeEventListener('beforeunload', handleBeforeUnload); // Remove the beforeunload listener
  //   };
  // }, [id, latitude, longitude]);

  // useEffect(() => {
  //   // Function to get location updates
  //   const handlePosition = (position) => {
  //     const { latitude, longitude } = position.coords;
  //     setLatitude(latitude); // Update state
  //     setLongitude(longitude); // Update state

  //     // Update the ref to the latest position
  //     locationRef.current = { latitude, longitude };
  //   };

  //   const getLocationUpdate = () => {
  //     if (navigator.geolocation) {
  //       locationIdRef.current = navigator.geolocation.watchPosition(
  //         handlePosition,
  //         (err) => {
  //           setError('Error getting location');
  //           console.error('Error in getting location:', err);
  //         },
  //         { enableHighAccuracy: true, maximumAge: 0, timeout: 27000 }
  //       );
  //     } else {
  //       alert('Sorry, your browser does not support geolocation!');
  //     }
  //   };

  //   // Initial location update
  //   getLocationUpdate();

  //   // Update location periodically
  //   intervalIdRef.current = setInterval(() => {
  //     const { latitude, longitude } = locationRef.current;
  //     if (latitude && longitude) {
  //       axios
  //         .put(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`, {
  //           latitude: latitude || null,
  //           longitude: longitude || null,
  //         })
  //         .catch((err) => {
  //           console.error('Failed to update location:', err);
  //         });
  //     }
  //   }, 5000); // Send location every 5000 ms

  //   // Handle the cleanup on component unmount (when user logs out or closes the tab)
  //   const handleBeforeUnload = () => {
  //     if (locationIdRef.current != null) {
  //       navigator.geolocation.clearWatch(locationIdRef.current);
  //     }
  //     if (intervalIdRef.current != null) {
  //       clearInterval(intervalIdRef.current); // Stop the interval
  //     }
  //   };

  //   // Listen for beforeunload event to stop execution when the page is closed or the user logs out
  //   window.addEventListener('beforeunload', handleBeforeUnload);

  //   // Cleanup on component unmount
  //   return () => {
  //     if (locationIdRef.current != null) {
  //       navigator.geolocation.clearWatch(locationIdRef.current);
  //     }
  //     if (intervalIdRef.current != null) {
  //       clearInterval(intervalIdRef.current); // Stop the interval
  //     }
  //     window.removeEventListener('beforeunload', handleBeforeUnload); // Remove the beforeunload listener
  //   };
  // }, [id]);

  // useEffect(() => {
  //   // Handle visibility changes when app goes to the background
  //   const handleVisibilityChange = () => {
  //     if (document.hidden) {
  //       // App is in background, potentially pause updates
  //       console.log('App is in the background');
  //     } else {
  //       // App is in foreground, continue location tracking
  //       console.log('App is in the foreground');
  //       getLocationUpdate(); // Restart location tracking
  //     }
  //   };

  //   // Function to get location updates
  //   const handlePosition = (position) => {
  //     const { latitude, longitude } = position.coords;
  //     setLatitude(latitude); // Update state
  //     setLongitude(longitude); // Update state

  //     // Update the ref to the latest position
  //     locationRef.current = { latitude, longitude };
  //   };

  //   const getLocationUpdate = () => {
  //     if (navigator.geolocation) {
  //       locationIdRef.current = navigator.geolocation.watchPosition(
  //         handlePosition,
  //         (err) => {
  //           setError('Error getting location');
  //           console.error('Error in getting location:', err);
  //         }
  //       );
  //     } else {
  //       alert('Sorry, your browser does not support geolocation!');
  //     }
  //   };

  //   // Initial location update
  //   getLocationUpdate();

  //   // Update location periodically
  //   intervalIdRef.current = setInterval(() => {
  //     const { latitude, longitude } = locationRef.current;
  //     if (latitude && longitude) {
  //       axios
  //         .put(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`, {
  //           latitude: latitude || null,
  //           longitude: longitude || null,
  //         })
  //         .catch((err) => {
  //           console.error('Failed to update location:', err);
  //         });
  //     }
  //   }, 5000); // Send location every 5000 ms

  //   // Listen to visibility changes (when app goes to background)
  //   document.addEventListener('visibilitychange', handleVisibilityChange);

  //   // Cleanup on component unmount
  //   return () => {
  //     if (locationIdRef.current != null) {
  //       navigator.geolocation.clearWatch(locationIdRef.current);
  //     }
  //     if (intervalIdRef.current != null) {
  //       clearInterval(intervalIdRef.current); // Stop the interval
  //     }
  //     document.removeEventListener('visibilitychange', handleVisibilityChange);
  //   };
  // }, [id]);

  // useEffect(() => {
  //   let locationId = null;
  //   let intervalId = null;

  //   const handlePosition = (position) => {
  //     const { latitude, longitude } = position.coords;
  //     setLatitude(latitude); // Update state
  //     setLongitude(longitude); // Update state

  //     // Update the ref to the latest position
  //     locationRef.current = { latitude, longitude };
  //   };

  //   const getLocationUpdate = () => {
  //     if (navigator.geolocation) {
  //       locationId = navigator.geolocation.watchPosition(
  //         handlePosition,
  //         (err) => {
  //           setError('Error getting location');
  //           console.error('Error in getting location:', err);
  //         }
  //       );
  //     } else {
  //       alert('Sorry, your browser does not support geolocation!');
  //     }
  //   };

  //   getLocationUpdate(); // Call once initially

  //   intervalId = setInterval(() => {
  //     // Use the latest location from the ref, which always holds the most recent coordinates
  //     const { latitude, longitude } = locationRef.current;

  //     if (latitude && longitude) {
  //       axios
  //         .put(`${process.env.REACT_APP_API_URL}/gps_unit/${id}`, {
  //           latitude: latitude || null,
  //           longitude: longitude || null,
  //         })
  //         .catch((err) => {
  //           console.error('Failed to update location:', err);
  //         });
  //     }
  //   }, 5000); // Send location every 5000 ms

  //   // Cleanup the geolocation watch and interval when the component unmounts
  //   return () => {
  //     if (locationId != null) {
  //       navigator.geolocation.clearWatch(locationId);
  //     }
  //     if (intervalId != null) {
  //       clearInterval(intervalId); // Stop the interval to prevent API calls
  //     }
  //   };
  // }, [id]);

  const handleLogout = () => {
    console.log('Logging out...'); // Debugging output
    clearTimeout(timeoutRef.current); // Clear the timeout explicitly
    navigate(`/login`);
  };

  const gpsPhoto = () => {
    getGpsUnitsPhoto()?.then((res) => {
      if (res) {
        const array = filter(res, (item) => item?.gps_unit_id === parseInt(id));
        setGpsData(reverse(array));
      }
    });
  };

  const gpsUnitMedical = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/gps_unit/medicalunits`
    );
    if (res?.status === 200) {
      setMedicalList(res?.data);
    }
  };

  const getAmbulance = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/gps_unit/${id}`
    );
    if (res?.status === 200) {
      setAmbulanceDetail(res?.data);
    }
  };

  useEffect(() => {
    gpsPhoto();
    gpsUnitMedical();
    getAmbulance();
  }, []);

  const capturePhoto = async () => {
    try {
      const imageSrc = webcamRef.current.getScreenshot();

      const coords = await new Promise((resolve, reject) =>
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve(pos.coords),
          reject
        )
      );

      const address = await getAddressFromCoords(
        coords.latitude,
        coords.longitude
      );

      const img = new Image();
      img.src = imageSrc;

      img.onload = async () => {
        try {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');

          // Draw original photo
          ctx.drawImage(img, 0, 0);

          // Lines to display
          const lines = [
            address,
            `Lat: ${coords.latitude.toFixed(
              5
            )} | Lng: ${coords.longitude.toFixed(5)}`,
            new Date().toLocaleString(),
          ];

          ctx.font = '16px Arial';
          const padding = 10;
          const lineHeight = 24;

          // Map and text sizing
          const mapWidth = 200;
          const textWidth = canvas.width - mapWidth - padding * 3;
          const boxHeight = Math.max(
            lineHeight * lines.length + padding * 2,
            100
          );
          const y = canvas.height - boxHeight;

          // Draw black background
          ctx.fillStyle = 'rgba(0,0,0,0.7)';
          ctx.fillRect(0, y, canvas.width, boxHeight);

          // Draw static map
          const staticMapUrl = `https://maps.googleapis.com/maps/api/staticmap?center=${coords.latitude},${coords.longitude}&zoom=14&size=${mapWidth}x${boxHeight}&markers=color:red%7C${coords.latitude},${coords.longitude}&key=YOUR_API_KEY`;
          const mapImg = new Image();
          mapImg.crossOrigin = 'Anonymous';
          mapImg.src = staticMapUrl;

          mapImg.onload = () => {
            try {
              const mapBottomPadding = 10; // extra space below map
              ctx.drawImage(
                mapImg,
                padding,
                y,
                mapWidth,
                boxHeight - mapBottomPadding
              );

              // Draw wrapped text on right
              ctx.fillStyle = 'white';
              ctx.textAlign = 'left';
              const textX = mapWidth + padding * 2;
              let textY = y + padding;

              lines.forEach((line) => {
                const words = line.split(' ');
                let lineText = '';
                words.forEach((word) => {
                  const testLine = lineText + word + ' ';
                  const metrics = ctx.measureText(testLine);
                  if (metrics.width > textWidth) {
                    ctx.fillText(lineText, textX, textY);
                    lineText = word + ' ';
                    textY += lineHeight;
                  } else {
                    lineText = testLine;
                  }
                });
                ctx.fillText(lineText, textX, textY);
                textY += lineHeight;
              });

              // Export stamped image
              const stampedDataURL = canvas.toDataURL('image/jpeg');
              const stampedFile = dataURLtoFile(
                stampedDataURL,
                `photo_${Date.now()}.jpg`
              );
              handleFileChange(stampedFile);
            } catch (err) {
              console.error('Error processing map image:', err);
            }
          };

          mapImg.onerror = () => {
            console.warn('Map failed to load, proceeding without map.');
            // Draw text even if map fails
            ctx.fillStyle = 'white';
            ctx.textAlign = 'left';
            const textX = mapWidth + padding * 2;
            let textY = y + padding;

            lines.forEach((line) => {
              const words = line.split(' ');
              let lineText = '';
              words.forEach((word) => {
                const testLine = lineText + word + ' ';
                const metrics = ctx.measureText(testLine);
                if (metrics.width > textWidth) {
                  ctx.fillText(lineText, textX, textY);
                  lineText = word + ' ';
                  textY += lineHeight;
                } else {
                  lineText = testLine;
                }
              });
              ctx.fillText(lineText, textX, textY);
              textY += lineHeight;
            });

            const stampedDataURL = canvas.toDataURL('image/jpeg');
            const stampedFile = dataURLtoFile(
              stampedDataURL,
              `photo_${Date.now()}.jpg`
            );
            handleFileChange(stampedFile);
          };
        } catch (err) {
          console.error('Error processing captured photo:', err);
        }
      };
    } catch (err) {
      console.error('Error capturing photo:', err);
    }
  };

  // const capturePhoto = () => {
  //   const imageSrc = webcamRef.current.getScreenshot();
  //   const byteString = atob(imageSrc.split(',')[1]);
  //   const mimeString = imageSrc.split(',')[0].split(':')[1].split(';')[0];
  //   const ab = new ArrayBuffer(byteString.length);
  //   const ia = new Uint8Array(ab);

  //   for (let i = 0; i < byteString.length; i++) {
  //     ia[i] = byteString.charCodeAt(i);
  //   }

  //   const blob = new Blob([ab], { type: mimeString });
  //   const file = new File([blob], `photo_${Date.now()}.jpg`, {
  //     type: mimeString,
  //   });

  //   handleFileChange(file);
  // };

  const handleFileChange = async (file) => {
    const res = await fileUploadService?.handleFileUpload(file);

    if (res?.status === 200) {
      const uploadedURL = `${res?.data?.filename}`;
      if (isCaptureId) {
        setCaptureId(uploadedURL);
      } else {
        setUrl(uploadedURL);
      }
      setIsStart(false);
      setIsCaptuerId(false);
      gpsPhoto();
    }
  };

  const validationSchema = Yup.object().shape({
    description: Yup.string().required('Description is required'),
    code: Yup.string().required('Code selection is required'),
  });

  const handleSubmit = async (values, resetForm) => {
    const res = await addGpsUnitsPhoto({
      gps_unit_id: parseInt(id),
      name: ambulanceDetail?.name,
      number: ambulanceDetail?.number,
      photo: `${captureId},${url}`,
      description: values?.description,
      emcode: values?.code,
      event_id: parseInt(localStorage?.getItem('event_id')),
    });
    if (res) {
      toast?.success('Data added successfully');
      resetForm();
      setUrl(null);
      setCaptureId(null);
      gpsPhoto();
    }
  };

  return (
    <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '64px' }}>
      <Container
        maxWidth='sm'
        sx={{
          mt: 2,
          bgcolor: '#f9f9f9',
          p: '0 !important',
          boxShadow: 2,
          borderRadius: 2,
        }}
      >
        <Typography
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            fontSize: { xs: '1.1rem', md: '1.2rem' },
            color: '#333',
            fontWeight: 600,
            padding: '1rem',
            pb: '0 !important',
          }}
        >
          AMBULANCE {ambulanceDetail?.name}
        </Typography>
        <Grid
          container
          spacing={2}
          direction='column'
          mb={'2rem'}
          sx={{ ml: '0!important', width: 'auto', padding: '1rem' }}
        >
          <Formik
            initialValues={{ description: '', code: '' }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm }) => {
              if (url) {
                handleSubmit(values, resetForm);
              } else {
                toast?.info('Please take photo!!');
              }
            }}
          >
            {({ handleChange, handleBlur, values, setFieldValue }) => (
              <Form>
                <Grid item xs={12} my={2}>
                  <strong style={{ fontSize: 'small' }}>SELECT CODE</strong>
                  <Field
                    as={Select}
                    fullWidth
                    name='code'
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.code}
                  >
                    <MenuItem value='Code green - fall'>
                      CODE GREEN - FALL
                    </MenuItem>
                    <MenuItem value='Code blue - unresponsive'>
                      CODE BLUE - UNRESPONSIVE
                    </MenuItem>
                    <MenuItem value='Code white - responsive but bad'>
                      CODE WHITE - RESPONSIVE BUT BAD
                    </MenuItem>
                  </Field>
                  <div style={{ fontSize: '0.7rem', color: 'red' }}>
                    <ErrorMessage name='code' />
                  </div>
                  <strong style={{ fontSize: 'small' }}>DESCRIPTION</strong>
                  <Field
                    as={TextField}
                    fullWidth
                    name='description'
                    onChange={(e) => {
                      const capitalizedValue = e.target.value?.toUpperCase();
                      setFieldValue('description', capitalizedValue);
                    }}
                    onBlur={handleBlur}
                    value={values.description}
                  />
                  <div style={{ fontSize: '0.7rem', color: 'red' }}>
                    <ErrorMessage name='description' />
                  </div>
                </Grid>
                <Typography
                  variant='body1'
                  alignItems='center'
                  display='flex'
                  sx={{ mt: 0 }}
                >
                  <MdLocationOn
                    fill='#0071b6'
                    sx={{ marginRight: 1 }}
                    size={22}
                  />
                  {latitude && longitude
                    ? `${latitude}, ${longitude}`
                    : 'Fetching location...'}
                </Typography>
                <Grid item>
                  {(url || captureId) && (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      {captureId && (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}/images/${captureId}`}
                          alt='Captured'
                          style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '5px',
                            marginTop: '12px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          }}
                        />
                      )}
                      {url && (
                        <img
                          src={`${process.env.REACT_APP_IMAGE_URL}/images/${url}`}
                          alt='Captured'
                          style={{
                            width: '50px',
                            height: '50px',
                            borderRadius: '5px',
                            marginTop: '12px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                          }}
                        />
                      )}
                    </Box>
                  )}{' '}
                  {!isStart && (
                    <Box sx={{ display: 'flex', gap: 2 }}>
                      <Button
                        variant='contained'
                        onClick={() => {
                          setIsStart(true);
                          setIsCaptuerId(true);
                        }}
                        sx={{
                          width: '50%',
                          mt: 2,
                          bgcolor: '#28a745',
                          '&:hover': { bgcolor: '#218838' },
                          textTransform: 'none',
                          padding: '0.4rem',
                          height: '3rem',
                          whiteSpace: 'nowrap',
                          gap: 1,
                          display: 'flex',
                        }}
                      >
                        <img
                          src={BIP}
                          width={38}
                          height={45}
                          style={{
                            borderRadius: '50%',
                            paddingTop: '0.2rem',
                            paddingBottom: '0.3rem',
                          }}
                        />{' '}
                        <span>CAPTURE BIB</span>
                      </Button>
                      <Button
                        variant='contained'
                        onClick={() => setIsStart(true)}
                        sx={{
                          width: '50%',
                          mt: 2,
                          bgcolor: '#28a745',
                          '&:hover': { bgcolor: '#218838' },
                          textTransform: 'none',
                          padding: '0.4rem',
                          height: '3rem',
                          whiteSpace: 'nowrap',
                          gap: 1,
                          display: 'flex',
                        }}
                      >
                        <IoCamera size={32} /> <span>TAKE PHOTO</span>
                      </Button>
                    </Box>
                  )}
                  {isStart && (
                    <>
                      <Webcam
                        audio={false}
                        ref={webcamRef}
                        screenshotFormat='image/jpeg'
                        videoConstraints={{ facingMode }}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                        }}
                        // screenshotFormat='image/jpeg'
                        // videoConstraints={{
                        //   facingMode: facingMode,
                        //   width: { ideal: 1920 }, // Reduce resolution to Full HD
                        //   height: { ideal: 1080 },
                        //   // width: { ideal: 3840 },
                        //   // height: { ideal: 2160 },
                        // }}
                        // className='responsive-webcam'
                      />

                      <MdFlipCameraIos
                        style={{ marginRight: '5px', cursor: 'pointer' }}
                        fill='#1876D1'
                        onClick={toggleCamera}
                        size={25}
                      />

                      <Button
                        variant='contained'
                        onClick={capturePhoto}
                        type='button'
                        fullWidth
                        sx={{
                          mt: 2,
                          bgcolor: '#28a745',
                          fontSize: '0.875rem',
                          textTransform: 'none',
                          height: '3rem',
                        }}
                      >
                        CAPTURE PHOTO
                      </Button>
                    </>
                  )}
                </Grid>
                <Button
                  type='submit'
                  variant='contained'
                  fullWidth
                  disabled={isEmpty(url) && isEmpty(captureId)}
                  sx={{
                    mt: 2,
                    textTransform: 'none',
                    bgcolor: '#007bff',
                    height: '3rem',
                    '&:hover': { bgcolor: '#0056b3' },
                  }}
                >
                  SUBMIT
                </Button>
                {!isEmpty(medicalList) && (
                  <Box sx={{ mt: 3 }}>
                    <Grid
                      container
                      spacing={2}
                      sx={{ padding: '0 !important' }}
                    >
                      {map(medicalList, (data, index) => (
                        <Grid
                          item
                          xs={4}
                          key={index}
                          sx={{ padding: '5px 22px 0px 22px!important' }}
                        >
                          <Card sx={{ padding: 0.3 }}>
                            <Button
                              variant='contained'
                              sx={{
                                padding: '6px 6px',
                                display: 'flex',
                                justifyContent: 'center', // Horizontally center the content
                                alignItems: 'center', // Vertically center the content
                                width: '100%',
                              }}
                              color='error'
                              fullWidth
                              onClick={() =>
                                window.open(
                                  `https://www.google.com/maps?q=${data?.latitude},${data?.longitude}`,
                                  '_blank'
                                )
                              }
                            >
                              {data?.name}
                              {/* {<CiMedicalCross size={16} />} */}
                            </Button>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>
                )}
              </Form>
            )}
          </Formik>

          {gpsData?.length > 0 && (
            <TableContainer
              component={Paper}
              sx={{ width: '100%', mt: 2, boxShadow: 1, mb: 2 }}
            >
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        backgroundColor: '#2F3542',
                        color: '#fff',
                        fontWeight: 600,
                        borderRight: '1px solid #FFF',
                        borderTopLeftRadius: '1rem',
                      }}
                    >
                      TIME
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: '#2F3542',
                        color: '#fff',
                        fontWeight: 600,
                        borderRight: '1px solid #FFF',
                      }}
                    >
                      CODE
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: '#2F3542',
                        color: '#fff',
                        fontWeight: 600,
                        borderRight: '1px solid #FFF',
                      }}
                    >
                      DESCRIPTION
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: '#2F3542',
                        color: '#fff',
                        fontWeight: 600,
                        borderRight: '1px solid #FFF',
                      }}
                    >
                      BIB ID
                    </TableCell>
                    <TableCell
                      sx={{
                        backgroundColor: '#2F3542',
                        color: '#fff',
                        fontWeight: 600,
                        borderRight: '1px solid #FFF',
                        borderTopRightRadius: '1rem',
                      }}
                    >
                      PHOTO
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {gpsData?.map((data, index) => {
                    const getCode = () => {
                      if (data?.emcode === 'Code green') {
                        return 'green-alert.png';
                      } else if (data?.emcode === 'Code blue ') {
                        return 'blue-alert.png';
                      } else {
                        return 'white-alert.png';
                      }
                    };

                    return (
                      <TableRow
                        key={index}
                        sx={{
                          backgroundColor: index % 2 === 0 ? '#fff' : '#eaf3ff',
                        }}
                      >
                        <TableCell sx={{ color: 'red', fontWeight: 550 }}>
                          {moment(data?.date_added)?.format('HH:mm')}
                        </TableCell>
                        <TableCell>
                          <img
                            src={`${process.env.PUBLIC_URL}/icons/${getCode()}`}
                            alt='Captured'
                            style={{
                              borderRadius: '5px',
                              width: '40px',
                              height: '35px',
                            }}
                          />
                        </TableCell>
                        <TableCell>{data?.description}</TableCell>
                        <TableCell>
                          <img
                            src={
                              `${process.env.REACT_APP_IMAGE_URL}/images/${
                                split(data?.photo, ',')?.[0]
                              }` || ''
                            }
                            alt='Captured'
                            style={{
                              borderRadius: '5px',
                              width: '40px',
                              height: '35px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleOpen();
                              setImageUrl(split(data?.photo, ',')?.[0]);
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <img
                            src={
                              `${process.env.REACT_APP_IMAGE_URL}/images/${
                                split(data?.photo, ',')?.[1]
                              }` || ''
                            }
                            alt='Captured'
                            style={{
                              borderRadius: '5px',
                              width: '40px',
                              height: '35px',
                              cursor: 'pointer',
                            }}
                            onClick={() => {
                              handleOpen();
                              setImageUrl(split(data?.photo, ',')?.[1]);
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Container>
      {modalOpen && (
        <ImageModal
          open={modalOpen}
          handleClose={handleClose}
          imageUrl={imageUrl}
        />
      )}
    </div>
  );
};

export default AmbulanceTracker;

export const AmbulancePage = () => {
  // const [tabValue, setTabValue] = React.useState(0);

  // return (
  //   <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
  //     <UserHeader />

  //     <div style={{ flex: 1, overflowY: 'auto', paddingBottom: '64px' }}>
  //       {tabValue === 0 ? <AmbulanceTracker /> : <CUChat />}
  //     </div>

  //     {/* Bottom Tabs Footer */}
  //     <Paper
  //       sx={{ position: 'fixed', bottom: 0, left: 0, right: 0 }}
  //       elevation={3}
  //     >
  //       <BottomNavigation
  //         showLabels
  //         value={tabValue}
  //         onChange={(event, newValue) => {
  //           setTabValue(newValue);
  //         }}
  //       >
  //         <BottomNavigationAction
  //           label='Ambulance Tracker'
  //           icon={<LocalHospitalIcon />}
  //         />
  //         <BottomNavigationAction label='Chat' icon={<ChatIcon />} />
  //       </BottomNavigation>
  //     </Paper>
  //   </div>
  // );

  return <CUChat />;
};
